export { FocusTrap as default } from '@mui/base/FocusTrap';